import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import 'vuetify/styles'

export default createVuetify({
  components,
  directives,
  defaults: {
    global: {
      style: {
        fontFamily: 'var(--font-family-base)',
        letterSpacing: 'var(--letter-spacing-normal)'
      }
    },
    VBtn: {
      class: 'weight-semibold'
    }
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#A56A43',
          'primary-darken-1': '#7E4E31',
          secondary: '#64554B',
          'secondary-darken-1': '#463a31',
          accent: '#C08A62',
          'accent-darken-1': '#9A6744',
          info: '#C89D7C',
          success: '#7F9B6A',
          warning: '#CC8A5B',
          error: '#B86B6B',
          background: '#FBF6F1',
          surface: '#FFFCF8',
          'surface-variant': '#F6EDE4',
          'on-surface-variant': '#64554B'
        }
      }
    }
  }
})
